import React from "react";
import Box from "@material-ui/core/Box";
import Chip from "@material-ui/core/Chip";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import {
  containsCannedResponse,
  toggleCannedResponse,
} from "./cannedReviewResponses";

const useStyles = makeStyles((theme) => ({
  heading: {
    fontWeight: 600,
    marginTop: theme.spacing(1.5),
    marginBottom: theme.spacing(0.5),
  },
  hint: {
    display: "block",
    marginBottom: theme.spacing(0.75),
    color: theme.palette.text.secondary,
  },
  chipRow: {
    display: "flex",
    flexWrap: "wrap",
    gap: theme.spacing(0.75),
    marginBottom: theme.spacing(1.5),
  },
}));

export default function CannedResponseChips({ presets, value, onToggle }) {
  const classes = useStyles();

  return (
    <>
      <Typography className={classes.heading} variant="body2">
        Canned responses:
      </Typography>
      <Typography className={classes.hint} variant="caption">
        Click a preset to insert it. Click again to remove. You can still edit
        the text afterward.
      </Typography>
      <Box className={classes.chipRow}>
        {presets.map((preset) => {
          const selected = containsCannedResponse(value, preset.body);
          return (
            <Chip
              key={preset.id}
              label={preset.label}
              size="small"
              clickable
              color={selected ? "primary" : "default"}
              variant={selected ? "default" : "outlined"}
              onClick={() => {
                onToggle({
                  preset,
                  nextValue: toggleCannedResponse(value, preset.body),
                  inserted: !selected,
                });
              }}
            />
          );
        })}
      </Box>
    </>
  );
}
